import { render, staticRenderFns } from "./SysAnnouncementList.vue?vue&type=template&id=584dffe8&scoped=true&"
import script from "./SysAnnouncementList.vue?vue&type=script&lang=js&"
export * from "./SysAnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./SysAnnouncementList.vue?vue&type=style&index=0&id=584dffe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584dffe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584dffe8')) {
      api.createRecord('584dffe8', component.options)
    } else {
      api.reload('584dffe8', component.options)
    }
    module.hot.accept("./SysAnnouncementList.vue?vue&type=template&id=584dffe8&scoped=true&", function () {
      api.rerender('584dffe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysAnnouncementList.vue"
export default component.exports